module.exports = __webpack_public_path__ + "img/img10.b65206e6.jpg";